<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer005">
<p class="book-pages---regular"><span class="charoverride"><br class="calibre1"/></span></p>
<h1 class="book-pages---regular"><span class="charoverride">Dedication</span></h1>
<p class="basic-paragraph"><span class="charoverride1"><br class="calibre1"/></span></p>
<p class="basic-paragraph"><span class="charoverride1">This book is dedicated to my very dear and much admired Mr Witherspoon, my fourth grade teacher at Geelong Road State School, who not only believed I could read but gave me the key to the book cabinet, beginning my lifelong affair with literature. I have never had a better present. And at last I get a chance to say thank you.</span></p>
<p class="basic-paragraph"><span class="charoverride1">With thanks to Catherine Howat’s kind expertise on ships, Jean Greenwood’s recall of music, Maggie Walsh’s Maori wisdom, David Greagg’s navigation, Dennis, Mark and Ben Pryor.</span></p>
<p class="basic-paragraph"><span class="charoverride1">And in very loving memory of my cousin Muriel Wright, who died before she could read this. I hope she would have liked it. Missed much more than she would have believed.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?1ce56038